import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminSettings = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Informations</h2>
        <small className="text-muted">
          Configurer les informations du site
        </small>
      </div>
      
      <SchemaManager
        schemaKey="setting"
        endpoint="/api/setting"
      />
    </div>
  );
};

export default AdminSettings;